import { api } from "./api";

const modelApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllModel: builder.query({
      query: () => "all_model",
      providesTags: ["all_model"],
    }),
    getAllStockModel: builder.query({
      query: () => "all_stock_model",
      providesTags: ["all_model"],
    }),
    getStockByModelId: builder.query({
      query: (modelId) => `single_stock_model?modelId=${modelId}`,
      providesTags: ["all_model"],
    }),
    addNewModel: builder.mutation({
      query: (newData) => ({
        url: "create_model",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["all_model"],
    }),
    removeModel: builder.mutation({
      query: (id) => ({
        url: `model_delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["all_model"],
    }),
    editModel: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `model_update/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["all_model"],
    }),
  }),
});

export const {
  useGetAllModelQuery,
  useGetAllStockModelQuery,
  useGetStockByModelIdQuery,
  useAddNewModelMutation,
  useRemoveModelMutation,
  useEditModelMutation,
} = modelApi;
